import { axios } from 'lib/axios';
import { useNotificationStore } from 'stores/notifications';
import { useMutation } from 'react-query';

export const joinWaitlist = ({ data }) => {
  return axios.post('/v1/waitlist', data);
};
